var _circle, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path10, _rect3, _rect4, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHow3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 133.434C113.689 133.434 141 129.083 141 123.717C141 118.35 113.689 114 80 114C46.3106 114 19 118.35 19 123.717C19 129.083 46.3106 133.434 80 133.434Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.083 40.7414H130.672L127.003 32.4856C126.664 31.7224 125.907 31.2305 125.072 31.2305H106.683C105.848 31.2305 105.091 31.7224 104.752 32.4856L101.083 40.7414Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.11 40.6321H130.7V122.113H101.11V40.6321Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.559 41.7914V113.652M103.196 41.7914V113.652",
    stroke: "#26D552",
    strokeWidth: 2.11355
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.874 60.8168V75.6117M115.874 60.8168L121.158 67.1575M115.874 60.8168L110.59 67.1575",
    stroke: "#26D552",
    strokeWidth: 2.11355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.05677,
    y: 1.05677,
    width: 14.7948,
    height: 6.34064,
    rx: 1.05677,
    transform: "matrix(-1 0 0 1 122.218 46.0253)",
    fill: "#F8F8F8",
    stroke: "url(#paint3_linear)",
    strokeWidth: 2.11355
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 29.5897,
    height: 8.45419,
    transform: "matrix(-1 0 0 1 130.672 113.652)",
    fill: "#9FA1A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.083 43.9084L91.1834 40.6086C89.8148 40.1524 88.4015 41.1711 88.4015 42.6137V103.678C88.4015 104.588 88.9836 105.395 89.8467 105.683L101.083 109.428V43.9084Z",
    fill: "url(#paint4_linear)",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7 40.7414H29.1104L32.7796 32.4856C33.1188 31.7224 33.8757 31.2305 34.711 31.2305H53.0994C53.9346 31.2305 54.6915 31.7224 55.0308 32.4856L58.7 40.7414Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1104 40.6321H58.7V122.113H29.1104V40.6321Z",
    fill: "url(#paint6_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2272 41.7914V113.652M56.5897 41.7914V113.652",
    stroke: "#26D552",
    strokeWidth: 2.11355
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9119 60.8168V75.6117M43.9119 60.8168L38.6281 67.1575M43.9119 60.8168L49.1958 67.1575",
    stroke: "#26D552",
    strokeWidth: 2.11355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5144,
    y: 47.082,
    width: 14.7948,
    height: 6.34064,
    rx: 1.05677,
    fill: "#F8F8F8",
    stroke: "url(#paint7_linear)",
    strokeWidth: 2.11355
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1136,
    y: 113.652,
    width: 29.5897,
    height: 8.45419,
    fill: "#9FA1A4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7032 43.9084L68.6026 40.6086C69.9712 40.1524 71.3845 41.1711 71.3845 42.6137V103.678C71.3845 104.588 70.8024 105.395 69.9393 105.683L58.7032 109.428V43.9084Z",
    fill: "url(#paint8_linear)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 123.717) rotate(90) scale(9.71681 61)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 115.878,
    y1: 31.2305,
    x2: 115.878,
    y2: 40.7414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 116,
    y1: 40.5,
    x2: 116,
    y2: 113.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362A2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 8.45419,
    y1: 0,
    x2: 8.45419,
    y2: 8.45419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 100.786,
    y1: 72.5,
    x2: 88.786,
    y2: 63.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0462AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B61A6",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 43.9052,
    y1: 31.2305,
    x2: 43.9052,
    y2: 40.7414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 44,
    y1: 40.5,
    x2: 44,
    y2: 113.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362A2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 43.9118,
    y1: 46.0253,
    x2: 43.9118,
    y2: 54.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 59,
    y1: 72.5,
    x2: 71,
    y2: 63.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0462AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B61A6",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow3);
export default __webpack_public_path__ + "static/media/how_3.52c9eac8f84f011cd15f9bd92da93ff0.svg";
export { ForwardRef as ReactComponent };